import React from 'react'
import { Card } from 'react-bootstrap'
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { isMobile } from 'react-device-detect';

const IndustrialModeling = (props) => {
    const responsive = {
        desktop: {
          breakpoint: { max: 5000, min: 1024 },
          items: 1,
        //   slidesToSlide: 3 // optional, default to 1.
        },
        tablet: {
          breakpoint: { max: 1024, min: 464 },
          items: 1,
        //   slidesToSlide: 2 // optional, default to 1.
        },
        mobile: {
          breakpoint: { max: 464, min: 0 },
          items: 1,
        //   slidesToSlide: 1 // optional, default to 1.
        }
      };
  return (
    <>
        <Card className='text-center no-border rounded-0 industrial-modeling-top-section container'>
        <Card.Body>
            <Card.Title className='industrial-modeling-title'>Industrial Modeling</Card.Title>
            <Card.Text className='industrial-modeling-text'>
            With the increased adoption of automation, Internet of things (IoT) data, interconnected systems and application of AI, Industry 4.0 is increasingly at the forefront of 3D modeling adoption in manufacturing and industrial facilities. Digital Twins of entire assembly lines or factories can display data in real time in situ on virtual representations of the facilities. These large - scale 3D models can also be used for worker training and assessm ent through production of 3D animations as well as immersive VR training.
            </Card.Text>
            <Card.Subtitle className="industrial-modeling-subtitle py-4">Animated Factory Robot</Card.Subtitle>
                <div className='industrial-modeling-section'>
                    <video className='industrial-modeling-player container' muted loop autoPlay playsInline onContextMenu={(e) => e.preventDefault()}>
                        <source src={process.env.PUBLIC_URL + "assets/industrial/video/ARM_Factory_Render_v001.mp4"} type="video/mp4"/>
                    </video>
                </div>
        </Card.Body>
        </Card>
        <Card className='no-border rounded-0 industrial-modeling-bottom-section py-5 container'>
            <Card.Body>
                {/* <Card.Subtitle className="industrial-modeling-subtitle py-4">New Industrial Machine Modeling</Card.Subtitle> */}
                <Card.Text className='industrial-modeling-text'>
                Digital twins give companies a virtual view of their machines, systems, facilities, and assets by using graphics, sensors, data, and more. We can build graphic models for digital twins using existing CAD drawings or, when needed, from scratch.
                <br />
                <br />
                </Card.Text>
                    <Carousel
                     responsive={responsive}
                     autoPlay={false}
                     arrows={isMobile ? false : true }
                     centerMode={ isMobile ? false : true }
                     slidesToSlide={1}
                     infinite={true}
                     showDots={true}
                    //  keyBoardControl={true}
                     renderDotsOutside={true}
                     draggable={false}
                     autoPlaySpeed={3000}
                    >
                        <div>
                            <img className="d-block w-100 px-md-2" src={process.env.PUBLIC_URL + "assets/industrial/images/ind002.jpg"} alt="" />
                        </div>
                        <div>
                            <img className="d-block w-100 px-md-2" src={process.env.PUBLIC_URL + "assets/industrial/images/ind003.jpg"} alt="" />
                        </div>
                        <div>
                            <img className="d-block w-100 px-md-2" src={process.env.PUBLIC_URL + "assets/industrial/images/ind004.jpg"} alt="" />
                        </div>
                        <div>
                            <img className="d-block w-100 px-md-2" src={process.env.PUBLIC_URL + "assets/industrial/images/ind005.jpg"} alt="" />
                        </div>
                        <div>
                            <img className="d-block w-100 px-md-2" src={process.env.PUBLIC_URL + "assets/industrial/images/ind001.jpg"} alt="" />
                        </div>
                    </Carousel>
            </Card.Body>
        </Card>
    </>
  )
}

export default IndustrialModeling
